import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M7.5 3.75 13.75 10 7.5 16.25"
	})
});
export default SvgCaretRight;
